import { render, staticRenderFns } from "./NhatKyKcsAll.vue?vue&type=template&id=27c86a6e&"
import script from "./NhatKyKcsAll.vue?vue&type=script&lang=js&"
export * from "./NhatKyKcsAll.vue?vue&type=script&lang=js&"
import style0 from "./NhatKyKcsAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports